import { createRouter, createWebHistory } from "vue-router";
import FirmwareAdd from "../views/FirmwareAdd.vue";
import CampaignAdd from "../views/CampaignAdd.vue";
import CampaignList from "../views/CampaignList.vue";
import EquipmentList from "../views/EquipmentList.vue";
import PatrimoineList from "../views/PatrimoineList.vue";
import CampaignDetail from "../views/CampaignDetail.vue";
import cardpage from "../views/EquipmentDetail.vue";
import FileProcessing from "../views/FileProcessing.vue";
import FileProcessingDetails from "../views/FileProcessingDetails.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: FirmwareAdd,
      name: "dmPortal_base",
      meta: {
        roles: ["dm-administrator", "dm-ufw-write", "guest"],
      },
    },
    {
      path: "/DmPortal",
      component: FirmwareAdd,
      name: "addFrimware",
      meta: {
        roles: ["dm-administrator", "dm-ufw-write"],
      },
    },
    {
      path: "/DmPortal/compaignadd",
      component: CampaignAdd,
      name: "addCompain",
      meta: {
        roles: ["dm-administrator", "dm-ufw-write"],
      },
    },
    {
      path: "/DmPortal/firmwarelist",
      component: () => import("../views/FirmwareList.vue"),
      name: "listOfFrimware",
      meta: {
        roles: ["dm-administrator", "dm-ufw-read", "dm-ufw-write"],
      },
    },
    {
      path: "/DmPortal/compaignlist",
      component: CampaignList,
      name: "listOfCompaign",
      meta: {
        roles: ["dm-administrator", "dm-ufw-read", "dm-ufw-write"],
      },
    },
    {
      path: "/DmPortal/equipmentlist",
      component: EquipmentList,
      name: "listOfEquipment",
      meta: {
        roles: ["dm-administrator", "dm-assets-read"],
      },
    },
    {
      path: "/DmPortal/PatrimoineList/:scope?/:deviceType?/:externalId?",
      component: PatrimoineList,
      name: "listOfPatrimoine",
      meta: {
        roles: ["dm-administrator", "dm-assets-read"],
      },
    },
    {
      path: "/DmPortal/equipmentdetail/:scope/:deviceType/:externalId/:target?",
      component: cardpage,
      name: "equipmentDetail",
      meta: {
        roles: ["dm-administrator", "dm-assets-read", "dm-assets-param-update"],
      },
    },
    {
      path: "/DmPortal/CampaignDetail/:campaignId",
      name: "campaigndetail",
      component: CampaignDetail,
      meta: {
        roles: ["dm-administrator", "dm-ufw-read", "dm-ufw-write"],
      },
    },
    {
      path: "/DmPortal/FileProcessing/:scope?/:reference?",
      component: FileProcessing,
      name: "fileProcessing",
      meta: {
        roles: ["dm-administrator", "dm-assets-read"],
      },
    },
    {
      path: "/DmPortal/FileProcessingDetails/:scope/:id",
      name: "FileProcessingDetails",
      component: FileProcessingDetails,
      meta: {
        roles: ["dm-administrator", "dm-assets-read"],
      },
    },
    {
      path: "/AccessDenied/:code",
      name: "Unauthorized",
      component: () => import("../views/UnauthorizedView"),
      meta: {
        roles: ["guest"],
      },
    },
    {
      path: "/DmPortal/client",
      component: () => import("../views/Client/Client.vue"),
      name: "manageClients",
      meta: {
        roles: ["dm-client-read", "dm-client-write", "dm-administrator"],
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.fullPath !== from.fullPath && to.href === "/") return false;
  next();
});

export default router;
